module.exports = __webpack_public_path__ + "static/media/events-icon.b20dd001.svg";